import * as d3 from 'd3'

export default {
  methods: {

    chart_Router() {

      // Canvas Group
      this.canvasChart = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)

      this.group.forEach((d,i)=> {
        this.primary.max = 0
        this.secondary.max = 0
        
        let cData = this.chartData.find(f=> f.GROUP == d.group && f.CDATE == this.timeline.cutoff)
        d.TOTAL = cData.TOTAL
        d.CUM_1ST = cData.CUM_1ST
        d.CUM_2ND = cData.CUM_2ND

        let chtData = this.chartData.filter(f=> f.GROUP == d.group && f.CDATE <= this.timeline.cutoff)
        this.exec_Router(chtData, d)
      })
    },


    exec_Router(data, d) {

      this.primary.max = d3.max([d3.max(data, c => c[this.chart.style[2].code]), d3.max(data, c => c[this.chart.style[3].code])])
      if(this.primary.max == 0) this.secondary.max = 25; else this.primary.max = this.gmx_maxBound5(this.primary.max)

      this.primary.max = this.gmx_maxBound5(this.primary.max)
      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])

      this.secondary.max = d3.max([d3.max(data, c => c[this.chart.style[0].code]), d3.max(data, c => c[this.chart.style[1].code])])
      if(this.secondary.max == 0) this.secondary.max = 25; else this.secondary.max = this.gmx_maxBound5(this.secondary.max)

      this.secondary.axis = d3.scaleLinear()
      .domain([0, this.secondary.max])
      .range([this.chart.height, 0])
      
      this.draw_ChartCanvas(d) // -----> draw_Elements.js
      this.draw_Timeline(d) // -----> draw_Timeline.js
      this.chart_Controller(data, d) // -----> draw_Chart.js
    }

  }
}
           